import { useInitData } from './useInitData'

export function useIsArchivedUsersInFlatDisplayed() {
  const initData = useInitData()

  return Boolean(initData?.uk?.config?.display_archived_users_in_flat)
}
